import { Reducers } from '@sda/enums/store';
import { FeedbackMask } from '@sda/sdk/masks';
import { SDK } from './helpers/sdk';
import type { FirestoreClientData } from './interfaces';
import type { Feedback as FeedbackInterface } from '@sda/interfaces/feedback';

/**
 * SDK Class to interact with Firestore Messages.
 */
export class Feedback extends SDK<FeedbackInterface> {
  constructor(apiClient: FirestoreClientData) {
    super(apiClient, Reducers.FEEDBACK);

    this.collection = this.fsh.Schema.Feedback;

    this.PublicMap = FeedbackMask;
  }
}
